import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class ReportingArchiveService {
    constructor(api) {
        this.api = api;
    }

    async getAll(params = {}) {
        try {
            const response = await withRetry(() => this.api.getAll(params), { maxRetries: 2 });
            return {
                success: true,
                data: response.data || [],
                meta: response.meta || {},
            };
        } catch (error) {
            if (error instanceof ApiError) throw error;
            if (error.statusCode || error.status) throw ApiError.fromResponse(error);
            throw new ApiError(error.message || 'Failed to fetch reporting archive', 500, 'UNKNOWN_ERROR', error);
        }
    }
}
